var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13V11.6667C14.1667 10.4241 13.3168 9.38004 12.1667 9.08401M9.83334 1.19384C10.8106 1.58943 11.5 2.54754 11.5 3.66667C11.5 4.78579 10.8106 5.7439 9.83334 6.13949M10.8333 13C10.8333 11.7575 10.8333 11.1362 10.6303 10.6462C10.3597 9.99277 9.84057 9.47364 9.18716 9.20299C8.6971 9 8.07585 9 6.83334 9H4.83334C3.59083 9 2.96957 9 2.47951 9.20299C1.82611 9.47364 1.30697 9.99277 1.03632 10.6462C0.833336 11.1362 0.833336 11.7575 0.833336 13M8.5 3.66667C8.5 5.13943 7.3061 6.33333 5.83334 6.33333C4.36058 6.33333 3.16667 5.13943 3.16667 3.66667C3.16667 2.19391 4.36058 1 5.83334 1C7.3061 1 8.5 2.19391 8.5 3.66667Z",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon2);
export default __webpack_public_path__ + "static/media/team-icon-2.c65d094e3f7c5109331f252c4bef3c29.svg";
export { ForwardRef as ReactComponent };